import type { FC } from 'react'
import { Toaster as HotToaster } from 'react-hot-toast'
import { alpha, useTheme } from '@mui/material/styles'

/*
  This is the base component for rendering react-hot-toast messages
*/

interface ToasterProps {
  /** Masque les toasts sans démonter : leur durée continue de s'écouler. */
  hidden?: boolean
}

export const Toaster: FC<ToasterProps> = ({ hidden = false }) => {
  const theme = useTheme()

  return (
    <HotToaster
      position="top-center"
      containerStyle={hidden ? { display: 'none' } : undefined}
      toastOptions={{
        style: {
          backdropFilter: 'blur(6px)',
          background: alpha(theme.palette.neutral[900], 0.8),
          color: theme.palette.common.white,
          boxShadow: theme.shadows[16],
        },
      }}
    />
  )
}
